"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaqItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Theme = require("../../Theme/Theme.variables");

var _Box = require("../Box/Box");

var _Text = require("../Text/Text");

var _Toggle = require("../Toggle/Toggle");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transition: all 0.15s ease;\n  color: ", ";\n  polygon {\n    fill: ", ";\n  }\n  :hover {\n    color: ", ";\n    polygon {\n      fill: ", ";\n    }\n  }\n  :active {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BoxStyled = (0, _styledComponents.default)(_Box.Box)(_templateObject(), function (props) {
  return (0, _Theme.variables)(props).grayDark;
});
var BoxToggle = (0, _styledComponents.default)(_Box.Box)(_templateObject2(), function (props) {
  return (0, _Theme.variables)(props).textPrimary;
}, function (props) {
  return (0, _Theme.variables)(props).textPrimary;
}, function (props) {
  return (0, _Theme.variables)(props).black;
}, function (props) {
  return (0, _Theme.variables)(props).black;
}, function (props) {
  return (0, _Theme.variables)(props).grayLighter;
});

var ThemelessFaqItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ThemelessFaqItem, _PureComponent);

  function ThemelessFaqItem() {
    _classCallCheck(this, ThemelessFaqItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemelessFaqItem).apply(this, arguments));
  }

  _createClass(ThemelessFaqItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          question = _this$props.question,
          children = _this$props.children;
      return _react.default.createElement("div", null, _react.default.createElement(_Toggle.Toggle, {
        style: {
          borderBottom: "1px solid ".concat((0, _Theme.variables)(this.props)['grayLight'])
        },
        trigger: _react.default.createElement(_Box.Box, {
          style: {
            width: '100%'
          }
        }, _react.default.createElement(BoxToggle, {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 3
        }, _react.default.createElement(_Text.Text, null, question))),
        content: _react.default.createElement(_Box.Box, null, _react.default.createElement(BoxStyled, {
          ml: 5
        }, _react.default.createElement(_Box.Box, {
          pb: 4,
          className: "faq-answer-inner"
        }, children)))
      }));
    }
  }]);

  return ThemelessFaqItem;
}(_react.PureComponent);

ThemelessFaqItem.displayName = 'FAQs'; // Prop Types

ThemelessFaqItem.propTypes = {
  question: _propTypes.default.string.isRequired,
  isOpen: _propTypes.default.bool
};
ThemelessFaqItem.defaultProps = {
  isOpen: false
}; // export { FaqItem };
// export default (FaqItem);

var FaqItem = (0, _styledComponents.withTheme)(ThemelessFaqItem);
exports.FaqItem = FaqItem;